<template>
    <div class="grid-container" data-aos="new-animation" data-aos-init="aos-init" > 
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
</template>

<script>

export default {
  name: 'grid-lines',
 
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
